<template>
  <v-sheet outlined class="mt-3">
    <v-tabs
       v-model="selectedtab"
       background-color="#586776" dark
       next-icon="mdi-arrow-right-bold"
       prev-icon="mdi-arrow-left-bold"
       show-arrows
    >
      <v-tabs-slider color="orange"></v-tabs-slider>
        
      <template v-for="(tab, t) in tabs">
        <!-- tab  title -->

        <v-tab :key="t" :disabled=!tab.enabled>
          <span v-if="tab.enabled" class="white--text">{{ tab.name }}</span>
          <span v-else>{{ tab.name }}</span>
        </v-tab>
      
        <!-- custom content ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <!-- gas -->
        <v-tab-item :key="t" v-if="tab.name == 'Gas'">
          <v-card outlined>
            <v-card-text>
              <FacilityCostsGas></FacilityCostsGas>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- solar -->
        <v-tab-item :key="t" v-if="tab.name == 'Solar'">
          <v-card outlined>
            <v-card-text>
              <FacilityCostsSolar></FacilityCostsSolar>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- storage -->
        <v-tab-item :key="t" v-if="tab.name == 'Storage'">
          <v-card outlined>
            <v-card-text>
              <FacilityCostsStorage></FacilityCostsStorage>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- carbon offsets -->
        <v-tab-item :key="t" v-if="tab.name == 'Carbon Offsets'">
          <v-card outlined>
            <v-card-text>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- cogen -->
        <v-tab-item :key="t" v-if="tab.name == 'Cogen'">
          <v-card outlined>
            <v-card-text>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- lighting -->
        <v-tab-item :key="t" v-if="tab.name == 'Lighting'">
          <v-card outlined>
            <v-card-text>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- wind -->
        <v-tab-item :key="t" v-if="tab.name == 'Wind'">
          <v-card outlined>
            <v-card-text>
            </v-card-text>
          </v-card>
        </v-tab-item>

      </template>

    </v-tabs>
  </v-sheet>

</template>

<script>
export default {
  name: 'Assets',
  data() {
    return {
      selectedtab: null,
      tabs: [
        { name: 'Gas', enabled: true }, 
        { name: 'Solar', enabled: true }, 
        { name: 'Storage', enabled: true }, 
        { name: 'Carbon Offsets', enabled: false },
        { name: 'Cogen', enabled: false }, 
        { name: 'Lighting', enabled: false }, 
        { name: 'Wind', enabled: false },
      ]
    }
  }
}
</script>
